import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { defaultLocale } from '@core/services/i18n/i18n.service';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withInterceptors([
        (req, next) => {
          const cloned = req.clone({ withCredentials: true });
          return next(cloned);
        },
        authInterceptor
      ])
    ),
    provideRouter(routes, withComponentInputBinding()),
    // provideAppInitializer(() => inject(VehicleService).load()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
        // Critical: bypass interceptors (like auth401Interceptor) for static translation files.
        useHttpBackend: true
      }),
      fallbackLang: defaultLocale,
      lang: defaultLocale
    })
  ]
};
